module.exports = __webpack_public_path__ + "48fe6f2b58291b84f9148da04faf6b94.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-38.svg
// module id = 575
// module chunks = 0